import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components';

const styles = {
  cardContent: {
    display: 'flex',
  },
  mainBoxes: {
    width: '100%',
    margin: '5px',
  },
  leftCards: {
    marginBottom: '10px',
    backgroundColor: '#e9e9dc',
  },
  mainTitle: {
    fontSize: '22px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
    textAlign: 'center',
  },
  title: {
    fontSize: '20px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
  },
  texts: {
    fontSize: '15px',
    fontWeight: 'bold',
    fontFamily: 'Nunito',
    color: 'gray',
    whiteSpace: 'pre-line',
  },
  contentRFiles: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  containerRFiles: {
    width: '220px',
    height: '40px',
    margin: '5px',
    display: 'flex',
    padding: '5px',
    alignItems: 'center',
    borderRadius: '10px',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    overflow: 'hidden',
  },
  textRFiles: {
    fontSize: '14px',
    fontFamily: 'Nunito',
    fontWeight: 'bold',
    textOverflow: 'ellipsis',
    width: '213px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};

export const Button = styled.button`
  width: ${(props) => (props.width === 'fullWidth' ? '100%' : '150px')};
  transition: all 0.5s ease-in-out;
  background-color: #FFA500;
  border: none;
  border-radius: 8px;
  color: white;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  font-family: 'Nunito', sans-serif;
  height: 36px;
  letter-spacing: 1px;
  margin:${(props) => (props.width === 'fullWidth' ? '0' : '0 5px 0 5px')};
  &:hover {
    background-color: #da8d00;
    border-color: #fff;
  }
  &:disabled {
    background-color: grey;
    border-color: #fff;
  }
}
`;

export const useStyles = makeStyles(styles);
